var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "white",
    stroke: "#D4D7E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 13.3333C16.8954 13.3333 16 12.4379 16 11.3333C16 10.2287 16.8954 9.33331 18 9.33331C19.1046 9.33331 20 10.2287 20 11.3333C20 12.4379 19.1046 13.3333 18 13.3333ZM18 19.9999C16.8954 19.9999 16 19.1044 16 17.9999C16 16.8953 16.8954 15.9999 18 15.9999C19.1046 15.9999 20 16.8953 20 17.9999C20 19.1044 19.1046 19.9999 18 19.9999ZM16 24.6667C16 25.7713 16.8954 26.6667 18 26.6667C19.1046 26.6667 20 25.7713 20 24.6667C20 23.5621 19.1046 22.6667 18 22.6667C16.8954 22.6667 16 23.5621 16 24.6667Z",
    fill: "#AFC0D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreMenuIcon);
export default __webpack_public_path__ + "static/media/moreMenuIcon.3169d178d7745c5ec3e0fee2a204827c.svg";
export { ForwardRef as ReactComponent };